export const Role = {
  Admin: 'ROLE_ADMIN',
  User: 'ROLE_USER',
  Notario: 'ROLE_NOTARIO',
  Oficial: 'ROLE_OFICIAL',
  Cliente: 'ROLE_CLIENTE',
}
